<template>
	<div class="row justify-content-center align-items-center">

		<div class="col-sm-4 col-md-3 form-group input-group input-group-lg">
			<select name="cls-select" id="cls-select" class="form-control form-control-lg custom-select" v-model="selected.cls">
				<option value="">CLASSE</option>
				<option value="1">1</option>
				<option value="2">2</option>
				<option value="3">3</option>
			</select>
		</div>

		<div class="col-sm-4 col-md-3 form-group input-group input-group-lg">
			<select name="sez-select" id="sez-select" class="form-control form-control-lg custom-select" v-model="selected.sez">
				<option value="">SEZIONE</option>
				<option value="A">A</option>
				<option value="B">B</option>
				<option value="C">C</option>
				<option value="D">D</option>
				<option value="E">E</option>
				<option value="F">F</option>
				<option value="G">G</option>
				<option value="H">H</option>
				<option value="I">I</option>
				<option value="L">L</option>
				<option value="M">M</option>
				<option value="N">N</option>
				<option value="O">O</option>
				<option value="P">P</option>
				<option value="Q">Q</option>
				<option value="R">R</option>
				<option value="S">S</option>
				<option value="T">T</option>
				<option value="U">U</option>
				<option value="V">V</option>
				<option value="Z">Z</option>
			</select>
		</div>

		<div class="col-sm-4 col-md-3 form-group input-group input-group-lg">
			<button class="btn btn-black" @click.prevent="addClass" title="Aggiungi classe">
				<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
				<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
				</svg>
			</button>
		</div>

		<div class="col-12 text-center mt-1" v-if="msgAddClass">
			<div class="text-white" v-html="msgAddClass"></div>
		</div>

	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'AddClassComponent',

	data() {
		return {
			ajaxObj: window.ajax_object,
			selected: {
				cls: '',
				sez: ''
			},
			msgAddClass: ''
		}
	},

	methods: {
		addClass() {
			this.msgAddClass = ''
			if(this.selected.cls == '' || this.selected.sez == '') {
				this.msgAddClass = 'Attenzione: selzionare classe e sezine da aggiungere'
			} else {
				this.msgAddClass = ''
				let url = this.ajaxObj.ajax_url

				var data = new FormData();
				data.append('action', 'nl_add_teacher_class')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('cls', this.selected.cls)
				data.append('sez', this.selected.sez)

				axios.post(url, data)
					.then((response) => {
						// console.log(response.data)
						if(response.data.error != '') {
							this.msgAddClass = response.data.error
						} else {
							this.msgAddClass = response.data.msgAddClass
							this.resetSelects()
							this.$emit('refreshClasses')
						}

					}, (error) => {
						console.log(error);
					});
			}
		},

		resetSelects() {
			this.selected.cls = ''
			this.selected.sez = ''
			this.msgAddClass = ''
		}
	}
}
</script>
